import { InternalAxiosRequestConfig } from "axios";
import { getCookieValue } from "src/constants/functions";
import { isAttachmentVersionedRequest } from "src/utils/attachmentVersion";
import { tokenStore } from "src/utils/tokenStore";

// export const addAuthHeader = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
//   const idToken = getCookieValue("idToken");
//   const refreshToken = getCookieValue("refreshToken");

//   if (!idToken && !refreshToken) {
//     logout();
//   }



//   if (idToken && refreshToken) {
//     config.headers["Authorization"] = JSON.stringify({
//       authorization: idToken,
//       refreshToken: refreshToken,
//     });
//   }


//   config.baseURL = config.baseURL?.toString()?.toLocaleLowerCase();
//   const [firstPart, ...rest] = config.url?.split("?") || [];
//   config.url = firstPart?.toString()?.toLocaleLowerCase() + (rest.length ? '?' + rest.join('?') : ''); 


//   return config;
// };
export const addAuthHeader = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  // Prefer in-memory access token (updated by the refresh flow). Fall back to
  // the cookie set on initial OAuth redirect before the login handler has
  // hydrated the in-memory store.
  const accessToken = tokenStore.getAccessToken() || getCookieValue("token");

  // NOTE: Do NOT call logout() here. If the token is missing/expired, let the
  // request fly — the response interceptor will catch the 401/403 and run
  // the refresh flow. Logging out here causes a navigation that aborts the
  // in-flight request before the interceptor can refresh + retry.
  if (accessToken) {
    config.headers["Authorization"] = `Bearer ${accessToken}`;
  }

  // M10-14277: opt into v2 attachment serving (pre-signed URLs) via a QUERY PARAM (not a
  // header) so it never triggers a CORS preflight, and only for the version-gated endpoints.
  // Absent => backend serves non-expiring public URLs (old mobile APKs are unaffected).
  if (isAttachmentVersionedRequest(config)) {
    config.params = { ...(config.params || {}), version: "v2" };
  }

  config.baseURL = config.baseURL?.toString()?.toLocaleLowerCase();
  const [firstPart, ...rest] = config.url?.split("?") || [];
  config.url = firstPart?.toString()?.toLocaleLowerCase() + (rest.length ? '?' + rest.join('?') : '');

  return config;
};
